"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSettings = exports.createSettings = exports.fetchSettingsByTag = void 0;
const abortable_fetch_1 = require("../../utils/abortable-fetch");
/**
 * Load all named settings for specified tag.
 *
 * @param url Url of service
 */
function fetchSettingsByTag(url, tag) {
    return (0, abortable_fetch_1.abortableFetch)(`${url}/by-tag/${tag}`, {
        method: 'GET',
    });
}
exports.fetchSettingsByTag = fetchSettingsByTag;
/**
 * Saves named settings.
 *
 * @param url Url of service
 */
function createSettings(url, settings) {
    return (0, abortable_fetch_1.abortableFetch)(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify(settings),
    });
}
exports.createSettings = createSettings;
/**
 * Clear named settings.
 *
 * @param meUrl Url of service
 */
function deleteSettings(url, id) {
    return (0, abortable_fetch_1.abortableFetch)(`${url}/${id}`, {
        method: 'DELETE',
    });
}
exports.deleteSettings = deleteSettings;
//# sourceMappingURL=named-settings-api.js.map